import React from 'react';

const Kickstart = ({ isCompleted }) => {
  return (
    <li className="message-row message-row-left">
      <div className="message-default message-questionnaire">
        <h5>Kickstart Questionnaire</h5>
        <p>
          To get a clear understanding of your goals, your trainer needs to know
          a few things about you. This should take about 3 minutes. If you’re
          not sure of your goals, you can discuss them in-person with your
          trainer during your next session.
        </p>
        <div className="message-check">
          {isCompleted ? (
            <label className="active">
              <i className="fas fa-check-square"></i>
              <span>Kickstart Questionnaire Completed</span>
            </label>
          ) : (
            <label>
              <i className="far fa-square"></i>
              <span>Kickstart Questionnaire Not Completed Yet</span>
            </label>
          )}
        </div>
      </div>
    </li>
  );
};

export default Kickstart;
